export default __webpack_public_path__ + "static/media/accuracyAccountsDemo_downloadMT4.2fda37ea.jpg";